export const USER_SET_GEO_LOCATION = 'USER:SET_GEO_LOCATION';

export function setGeoLocation(geocoded) {
    return (dispatch) => {
        dispatch({ type: USER_SET_GEO_LOCATION, geocoded });
    };
}
